import {
  HashtagApiResponse,
  HashtagSourcesApiResponse,
  StoryApiResponse,
} from 'api/api.types';
import { getHashtagApiResponse, getHashtagApiResponseNsi } from 'api/Hashtag';
import { GetServerSideProps, NextPage } from 'next';
import ErrorPage from 'src/components/error/ErrorPage';
import TopicPageNSI from 'src/page-components/topic/TopicPageNSI';
import TopicPageSI from 'src/page-components/topic/TopicPageSI';
import * as React from 'react';
import * as StoryApi from 'api/Story';
import { useEffect } from 'react';
import { Analytics, Events } from 'services/analytics';

interface TopicPageProps {
  topicTag?: string;
  hashtagApiNsi?: HashtagApiResponse | null;
  hashtagApi?: HashtagSourcesApiResponse | null;
  stories?: StoryApiResponse[] | null;
}

const TopicDynamicPage: NextPage<TopicPageProps> = ({
  topicTag,
  hashtagApi,
  hashtagApiNsi,
  stories,
}) => {
  useEffect(() => {
    if (topicTag && hashtagApi) {
      Analytics.logEvent({
        eventName: Events.consumption.viewTopic,
        properties: {
          topic: topicTag,
        },
        platforms: ['amplitude'],
      });
    }
  }, [topicTag]);

  if (!topicTag || !hashtagApi) return <ErrorPage />;

  return hashtagApiNsi ? (
    <TopicPageNSI
      topicTag={topicTag}
      hashtagApi={hashtagApiNsi}
      hashtagSources={hashtagApi}
      stories={stories ?? []}
    />
  ) : (
    <TopicPageSI topicTag={topicTag} hashtagApi={hashtagApi} />
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  params,
  req,
}) => {
  if (!params) return { props: {} };

  const topicTag = `${params.hashTag}`;
  let hashtagApi = null,
    hashtagApiNsi = null,
    stories = null;

  if (!topicTag) {
    return { props: {} };
  }

  try {
    if (!!req.cookies.token) {
      hashtagApi = await getHashtagApiResponse({
        name: topicTag,
      });
    } else {
      hashtagApiNsi = await getHashtagApiResponseNsi({
        name: topicTag,
      });
      hashtagApi = await getHashtagApiResponse({
        name: topicTag,
        limit: 5,
      });
      if (!hashtagApiNsi.seo) {
        hashtagApiNsi = null;
      } else {
        await StoryApi.getStories({
          offset: 0,
          limit: 4,
        }).then(response => {
          if (response?.objects) {
            stories = response.objects;
          }
        });
      }
    }
  } catch (_) {
    return { notFound: true };
  }

  if (!hashtagApi && !hashtagApiNsi) {
    return { notFound: true };
  }

  if (topicTag !== hashtagApi.hashtag) {
    //Redirect to the lowercase URL
    return {
      redirect: {
        destination: `/topic/${hashtagApi.hashtag}`,
        statusCode: 301,
      },
    };
  }

  return {
    props: {
      topicTag,
      hashtagApi,
      hashtagApiNsi,
      stories,
    },
  };
};

export default TopicDynamicPage;
